import { Vue, Component } from "vue-property-decorator";
import Iframe from '@/components/iframe/index.vue';
import user_module from '@/modules/user/index';

@Component({
  components:{
    Iframe
  }
})

export default class RequestDemo extends Vue {

  get fullSrc(){

    const site = user_module.currentSites.find((product: any) =>  product.site === this.site);

    const rd = site ? site.rd : '/requestdemo?product=TM&appstore=true&hide-topmenu=true'

    if (rd){

      let link = user_module.base + rd;

      const queryString = window.location.search;
			const urlParams = new URLSearchParams(queryString);
			const source = urlParams.get('source');

      if (source){
        link += '&source=' + source;
      }

      if (this.token){

        link += '&logged=true';
      }

      return link;
      
    }

    return '';
  }

  get site(){

    return this.$route.params.id;

  }

  get token(){

    return user_module.token;
  }

  mounted(){
    console.log('this.$route', this.$route);
    user_module.setRequest(true);
    document.documentElement.style.overflow = 'hidden';
    document.getElementsByTagName('body')[0].style.height = '100%';
  }

  beforeDestroy(){
    
    user_module.setRequest(false);
    document.documentElement.style.overflowY = 'scroll';
    const body: any = document.getElementsByTagName('body')[0];
    body.style.height = null;

  }
}
